import React, { Component } from 'react';

const Events = () => {
	return ( <h1>Training &amp; Events</h1> );
}
 
export default Events;